module.exports = __webpack_public_path__ + "files/045cb1adede2616066f90d5d5ae9080c.png";